import { Action, createReducer, on } from '@ngrx/store';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
    fetchSingleRecordSuccess,
    fetchTemplatesSuccess
} from './sent-correspondence.action';

import { SentCorrespondences, Templates } from './sent-correspondence.model';

export interface SentCorrespondencesRecordsState {
    listData: any[];
    templates: Templates[];
    total: number;
    singleData: SentCorrespondences;
    loading: boolean;
    error: any;
}

export const initialState: SentCorrespondencesRecordsState = {
    listData: [],
    templates: [],
    total: 0,
    singleData: null,
    loading: false,
    error: null,
};


export const SentCorrespondencesRecordReducer = createReducer(

    initialState,

    // All Records
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Single record
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    // Fetch Templates
    on(fetchTemplatesSuccess, (state, { templates }) => {
        return { ...state, templates, error: null };
    }),

    //Reset State
    on(resetState, () => initialState)  // Reset action handler
);